import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaTimes } from 'react-icons/fa';

import { teamMembers } from '@/features/whoWeAre/components/OurTeamSection';
import { logContactClick, logContactPopupOpen } from '@/utils/analytics-utils';
import { scrollToElement } from '@/utils/scroll-to-element';

export default function ContactPopup() {
  const [visible, setVisible] = useState(false);
  const [randomMember, setRandomMember] = useState(teamMembers[0]);

  const { t } = useTranslation('contactPopup');

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(true);
      logContactPopupOpen();

      const randomIndex = Math.floor(Math.random() * teamMembers.length);
      setRandomMember(teamMembers[randomIndex]);
    }, 60_000);

    return () => clearTimeout(timer);
  }, []);

  if (!visible) return null;

  return (
    <motion.div
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      className="fixed  flex justify-center items-center bottom-0 right-0 sm:bottom-20 sm:right-4 h-screen w-screen sm:w-fit sm:h-fit z-50 bg-black/60 sm:bg-transparent px-2"
    >
      <div className="flex flex-col items-center relative p-4 w-full max-w-md sm:w-[380px] min-h-64 sm:min-h-52 gap-4 bg-white rounded-2xl popup-shadow">
        <button className="absolute top-2 right-2" onClick={() => setVisible(false)}>
          <FaTimes size={18} />
        </button>

        <div className="flex flex-col sm:flex-row items-center sm:items-start w-full gap-4 sm:mt-4">
          <div className="flex flex-col">
            <div className="flex justify-center">
              <div
                className="flex justify-center items-center rounded-full w-12 h-12 overflow-hidden"
                style={{ backgroundColor: randomMember.backgroundColor }}
              >
                <img
                  src={randomMember.avatar}
                  alt={randomMember.position}
                  loading="lazy"
                  className="w-12 h-12"
                />
              </div>
            </div>
            <div className="text-center">
              <h1 className="font-semibold text-sm whitespace-nowrap">{randomMember.name}</h1>
            </div>
          </div>
          <div className="bg-background1 rounded-b-xl sm:rounded-tr-xl p-3 max-w-sm">
            {t('message')}
          </div>
        </div>
        <a
          href="https://calendar.app.google/G7bXxstBYoiuFNNX8"
          target="_balck"
          className="py-2 px-4 font-medium rounded-xl uppercase relative contact-button bg-button text-white text-sm self-end mt-auto"
          onClick={() => {
            logContactClick('PopupComponent', t('requestMeeting'));
          }}
        >
          {t('requestMeeting')}
        </a>
      </div>
    </motion.div>
  );
}
